{
	"title": "Accreditation",
	"records": {
		"pageTitle": "View Records",
		"count_one": "{{n}} record",
		"count_other": "{{n}} records",
		"exportCsv": "Export CSV",
		"register": "Register new person",
		"searchPlaceholder": "Full name, Acc name, registration, AC or ID number",
		"names": {
			"full": "Full name",
			"acc": "Acc name",
			"accHint": "The name printed on the card (Accreditation Name)",
			"toggle": "Both names",
			"toggleHint": "Show the full name with the Accreditation Name under it"
		},
		"filters": "Filters",
		"filtersCount": "Filters ({{n}})",
		"view": {
			"label": "View",
			"rows": "Detailed rows",
			"table": "Compact table"
		},
		"sort": {
			"number_desc": "Newest first",
			"number_asc": "Oldest first",
			"updated_desc": "Recently updated",
			"name_asc": "Name A–Z"
		},
		"chips": {
			"status": "Status",
			"organisation": "Organisation",
			"organisationSearch": "Search organisation",
			"games": "Games",
			"urgent": "Urgent printing",
			"multicard": "Multicard",
			"noPhoto": "No photo"
		},
		"pager": {
			"showing_one": "Showing {{from}} to {{to}} of {{total}} record",
			"showing_other": "Showing {{from}} to {{to}} of {{total}} records",
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No records",
			"selectPage": "Select all on this page"
		},
		"empty": {
			"filteredTitle": "No records match",
			"filteredDescription": "Try another name or clear the filters.",
			"clearFilters": "Clear filters",
			"noneTitle": "No records yet",
			"noneDescription": "Register the first person to start the list."
		},
		"row": {
			"select": "Select {{name}}",
			"acNo": "AC",
			"onApproval": "on approval",
			"reg": "Reg",
			"organisation": "Organisation",
			"mainFunction": "Main function",
			"subAgency": "Sub agency",
			"sport": "Sport",
			"genderAge": "Gender · Age",
			"contact": "Contact",
			"view": "View {{name}}",
			"edit": "Edit {{name}}",
			"urgentOn": "Mark urgent printing",
			"urgentOff": "Remove urgent printing",
			"createdBy": "Created by <b>{{name}}</b> · {{time}}",
			"createdAt": "Created {{time}}",
			"updatedBy": "Updated by <b>{{name}}</b> · {{time}}",
			"updatedAt": "Updated {{time}}",
			"whatChanged": "What changed",
			"ageYears": "{{age}}",
			"noPhoto": "No photo",
			"noPhotoHint": "No photo yet: this card cannot print"
		},
		"gender": {
			"MALE": "Man",
			"FEMALE": "Woman"
		},
		"idType": {
			"NATIONAL_ID": "MyKad / national ID",
			"PASSPORT": "Passport",
			"OTHER": "Other ID"
		},
		"table": {
			"name": "Name",
			"accreditationNo": "Accreditation No.",
			"organisation": "Organisation",
			"function": "Function",
			"sport": "Sport",
			"status": "Status",
			"created": "Created",
			"actions": "More actions for {{name}}",
			"open": "Open record",
			"edit": "Edit",
			"changeStatus": "Change status"
		},
		"bulk": {
			"selected_one": "{{n}} selected",
			"selected_other": "{{n}} selected",
			"selectAll_one": "Select all {{n}}",
			"selectAll_other": "Select all {{n}}",
			"allSelected_one": "All {{n}} matching record selected",
			"allSelected_other": "All {{n}} matching records selected",
			"changeStatus": "Change status",
			"markUrgent": "Mark urgent",
			"removeUrgent": "Remove urgent",
			"exportCsv": "Export CSV",
			"clear": "Clear selection",
			"tooMany": "Select at most {{max}} records, or use “Select all” to change the whole filtered list."
		},
		"urgent": {
			"onTitle": "Mark urgent printing?",
			"offTitle": "Remove urgent printing?",
			"onBody_one": "{{n}} record goes to the front of the AC-card print queue.",
			"onBody_other": "{{n}} records go to the front of the AC-card print queue.",
			"offBody_one": "{{n}} record leaves the urgent list. The print desk may already be working from it.",
			"offBody_other": "{{n}} records leave the urgent list. The print desk may already be working from it.",
			"confirmOn": "Mark urgent",
			"confirmOff": "Remove urgent",
			"doneOn_one": "{{n}} record marked urgent",
			"doneOn_other": "{{n}} records marked urgent",
			"doneOff_one": "{{n}} record no longer urgent",
			"doneOff_other": "{{n}} records no longer urgent",
			"failed": "Couldn't change urgent printing"
		},
		"export": {
			"filename": "accreditation-records",
			"started": "Export started",
			"failed": "Couldn't export the records",
			"col": {
				"registrationNo": "Registration No.",
				"accreditationNo": "Accreditation No.",
				"name": "Name",
				"idType": "ID type",
				"nationality": "Nationality",
				"sex": "Sex",
				"dateOfBirth": "Date of birth",
				"organisation": "Organisation",
				"mainFunction": "Main function",
				"subFunction": "Sub function",
				"subAgency": "Sub agency",
				"sport": "Sport",
				"status": "Status",
				"urgent": "Urgent",
				"created": "Created",
				"yes": "Yes",
				"no": "No"
			}
		},
		"filterSheet": {
			"title": "Filters",
			"organisation": "Responsible organisation",
			"organisationHint": "Changing this clears sub agency, main function and sub function.",
			"subAgency": "Sub agency",
			"mainFunction": "Main function",
			"subFunction": "Sub function",
			"subFunctionDisabled": "Choose a main function first",
			"status": "Status",
			"games": "Games",
			"toggles": "Show only",
			"urgent": "Urgent printing only",
			"multicard": "People holding more than one card",
			"noPhoto": "No photo only (cannot print)",
			"any": "Any",
			"search": "Search",
			"apply": "Show records",
			"clearAll": "Clear all"
		},
		"activity": {
			"title": "What changed",
			"subtitle": "{{name}} · {{reg}}"
		},
		"statusSheet": {
			"title": "Change status",
			"subtitle_one": "{{n}} record selected",
			"subtitle_other": "{{n}} records selected",
			"singleSubtitle": "{{name}} · {{reg}}",
			"now": "Now:",
			"nowCount": "{{n}} {{status}}",
			"nothing": "None of the selected records can change status from here.",
			"locked_one": "{{n}} record can't take this step",
			"locked_other": "{{n}} records can't take this step",
			"lockedMore": "and {{n}} more",
			"deselectLocked": "Deselect locked & continue",
			"refusedReason": {
				"not_in_scope": "outside your organisations",
				"locked": "its status doesn't allow it",
				"permission": "your group can't do this",
				"window": "registration is closed for its category",
				"self_approval": "you submitted it",
				"incomplete": "required details are missing",
				"reason_required": "a reason is required",
				"other": "refused"
			},
			"remarks": "Remarks",
			"remarksPlaceholder": "Tell the organisation what to fix",
			"remarksHint": "Shown to the organisation on the record.",
			"remarksRequired": "Remarks are required",
			"reason": "Reason",
			"reasonPlaceholder": "Why is this needed?",
			"reasonHint": "Kept in the record's activity.",
			"reasonRequired": "A reason is required",
			"cancel": "Cancel",
			"choose": "Choose a status",
			"confirm_one": "Set {{n}} record to {{status}}",
			"confirm_other": "Set {{n}} records to {{status}}",
			"confirmSingle": "Set to {{status}}",
			"done_one": "{{n}} record set to {{status}}",
			"done_other": "{{n}} records set to {{status}}",
			"partial": "{{done}} updated, {{refused}} refused",
			"failed": "Couldn't change the status",
			"allFilterNote": "Applies to every record matching the current filters ({{n}}).",
			"close": "Close",
			"refusedTitle_one": "{{n}} record was not changed",
			"refusedTitle_other": "{{n}} records were not changed",
			"refusedCount_one": "{{n}} record: {{reason}}",
			"refusedCount_other": "{{n}} records: {{reason}}"
		}
	},
	"record": {
		"title": "Record",
		"back": "Back to View Records",
		"accreditationNo": "Accreditation no.",
		"onApproval": "On approval",
		"registrationNo": "Registration no.",
		"statusLabel": "Status",
		"statusMenu": "Change status",
		"statusLocked": "No status change available to you",
		"needsRemarks": "Needs remarks",
		"needsReason": "Needs a reason",
		"actions": {
			"edit": "Edit",
			"urgentOn": "Urgent",
			"urgentOff": "Not urgent",
			"delete": "Delete"
		},
		"urgentDone": "Urgent printing on",
		"urgentUndone": "Urgent printing off",
		"urgentFailed": "Couldn't change urgent printing",
		"transitionDone": "Status set to {{status}}",
		"note": {
			"RETURN": "Returned by the host",
			"REJECTED": "Rejected by the host",
			"fixNow": "Fix now"
		},
		"activity": {
			"title": "Activity",
			"count_one": "{{n}} event",
			"count_other": "{{n}} events",
			"more": "Show more",
			"empty": "No activity yet",
			"failed": "Couldn't load the activity",
			"registered": "Registered",
			"deleted": "Deleted",
			"updated": "Details updated",
			"accessChanged": "Card access changed",
			"documentsChanged": "Documents changed",
			"system": "System",
			"aiAgent": "AI agent on behalf of {{name}}",
			"travel": {
				"arrivalSet": "Arrival set",
				"departureSet": "Departure set",
				"arrivalRemoved": "Arrival removed",
				"departureRemoved": "Departure removed",
				"arrivalDelaySet": "Arrival delay set",
				"departureDelaySet": "Departure delay set",
				"arrivalDelayCleared": "Arrival delay cleared",
				"departureDelayCleared": "Departure delay cleared",
				"changed": "Travel changed"
			},
			"inspect": "Show what changed",
			"detail": {
				"asRegistered": "As registered",
				"field": "Field",
				"before": "Before",
				"after": "After",
				"empty": "(empty)",
				"none": "No field changes to show for this entry.",
				"failed": "Couldn't load the changes",
				"groups": {
					"card": "Card",
					"person": "Person",
					"file": "Documents"
				},
				"fields": {
					"status_note": "Status remark",
					"submitted_at": "Submitted at",
					"submitted_by": "Submitted by",
					"approved_at": "Approved at",
					"approved_by": "Approved by",
					"urgent_printing": "Urgent printing",
					"delegation_role": "Delegation role",
					"remarks": "Remarks",
					"affiliated_organization_id": "Affiliated organisation",
					"employer_phone_country_code": "Organisation phone code",
					"has_last_surname": "Has a surname",
					"identification_issuing_authority": "Issuing authority",
					"phone_country_code": "Mobile country code",
					"emergency_phone_country_code": "Emergency phone country code",
					"height": "Height",
					"weight": "Weight",
					"shirt_size": "Shirt size",
					"pants_size": "Pants size",
					"shoe_size": "Shoe size",
					"consent_truthfulness": "Information is true",
					"consent_pdpa": "Data protection consent",
					"consented_at": "Consented at",
					"mode": "Mode",
					"entry_point_id": "Entry point",
					"flight_id": "Flight",
					"service_no": "Service number",
					"travel_date": "Travel date",
					"scheduled_at": "Scheduled time",
					"delayed_to": "Delayed to",
					"origin": "Origin",
					"needs_transport": "Needs Games transfer"
				}
			},
			"card": {
				"print_batched": "Added to a print batch",
				"printed": "Back from the printer",
				"activated": "Card activated",
				"reported_lost": "Card reported lost",
				"reported_stolen": "Card reported stolen",
				"reported_damaged": "Card reported damaged",
				"report_undone": "Card report undone",
				"generated": "Card file made",
				"sent_to_printer": "Sent to the printer",
				"received": "Card received"
			}
		},
		"sections": {
			"edit": "Edit",
			"editSection": "Edit {{section}}",
			"missing": "Missing",
			"zone": "Zone",
			"personal": "Personal information",
			"additional": "Additional information",
			"travel": "Arrival & departure",
			"sport": "Sport information",
			"card": "Card names"
		},
		"field": {
			"games": "Games",
			"organisation": "Responsible organisation",
			"category": "Category",
			"categoryValue": "{{name}} ({{code}})",
			"subAgency": "Sub agency",
			"function": "Function",
			"access": "Access",
			"editAccess": "Edit access",
			"noAccess": "No access codes yet",
			"document": "Document",
			"idNumber": "ID number",
			"nameInId": "Name as in ID",
			"surname": "Surname",
			"givenNames": "Given names",
			"nationality": "Nationality",
			"sex": "Sex",
			"dateOfBirth": "Date of birth",
			"placeOfBirth": "Place of birth",
			"issuedDate": "Date of issue",
			"expiryDate": "Date of expiry",
			"contactName": "Contact name",
			"mobile": "Mobile",
			"email": "Email",
			"residence": "Country of residence",
			"address": "Address",
			"emergencyContact": "Emergency contact",
			"emergencyPhone": "Emergency phone",
			"bloodGroup": "Blood group",
			"meals": "Meals",
			"allergies": "Allergies",
			"medical": "Medical",
			"wheelchair": "Wheelchair",
			"arrival": "Arrival",
			"departure": "Departure",
			"sport": "Sport",
			"venues": "Competition venues",
			"venuesNone": "Not scheduled yet",
			"venueInCity": "{{name}}, {{city}}",
			"nameOnCard": "Accreditation Name",
			"tvLongName": "Results name",
			"tvShortName": "Short name (TV)",
			"yes": "Yes",
			"no": "No",
			"photo": "Accreditation photo",
			"idFront": "ID copy (front)",
			"idBack": "ID copy (back)"
		},
		"delete": {
			"title": "Delete this record?",
			"description": "<strong>{{name}}</strong> ({{reg}}) is deleted for good. The person goes too when they hold no other card. Only drafts can be deleted.",
			"confirm": "Delete record",
			"failed": "Couldn't delete the record",
			"done": "Record {{reg}} deleted"
		},
		"access": {
			"title": "Card access",
			"description": "Pre-filled from the card's zone access rule. Saving a set different from the rule marks the card custom: rule changes then skip it.",
			"kinds": {
				"ZONE": "Access zones",
				"SEAT": "Seats",
				"TRANSPORT": "Transport",
				"MEAL": "Meals"
			},
			"transportNone": "None",
			"save": "Save access",
			"saved": "Card access saved",
			"failed": "Couldn't save the card access",
			"loadFailed": "Couldn't load the access codes",
			"custom": "Custom",
			"customTitle": "This card's access was edited by hand. Zone access rule changes skip it until it is reset to its rule.",
			"customHint": "Rule changes skip this card.",
			"reset": "Reset to rule",
			"resetConfirm": "Replace this card's access with what its rule grants?",
			"resetConfirmButton": "Reset",
			"resetDone": "Card access reset to its rule",
			"resetFailed": "Couldn't reset the card access"
		},
		"notFound": "This record doesn't exist or is outside your organisations.",
		"loadFailed": "Couldn't load this record",
		"status": {
			"DRAFT": "Draft",
			"SUBMITTED": "Submitted",
			"PENDING": "Pending",
			"APPROVED": "Approved",
			"RETURN": "Returned",
			"REJECTED": "Rejected",
			"WITHDRAWN": "Withdrawn"
		},
		"statusHint": {
			"DRAFT": "Saved, not submitted yet",
			"SUBMITTED": "Sent by the organisation, waiting for host review",
			"PENDING": "Host is checking security & eligibility",
			"APPROVED": "Accredited. Moves to card printing",
			"RETURN": "Sent back to the organisation to correct",
			"REJECTED": "Not accredited",
			"WITHDRAWN": "Withdrawn by the organisation or the host"
		},
		"transition": {
			"submit": "Submit",
			"unsubmit": "Back to draft",
			"pending": "Mark pending",
			"approve": "Approve",
			"return": "Return to the organisation",
			"reject": "Reject",
			"withdraw": "Withdraw",
			"reopen": "Reopen"
		},
		"transitionHint": {
			"submit": "Send it to the host for review",
			"unsubmit": "Take it back before the host picks it up",
			"pending": "Host is checking security & eligibility",
			"approve": "Accredited. The accreditation number is issued",
			"return": "Send it back to fix · remarks required",
			"reject": "Not accredited · remarks required",
			"withdraw": "Take the record out of the process",
			"reopen": "Back to Pending for another review · reason required"
		},
		"lock": {
			"status": "Not possible in this status",
			"scope": "This record is outside your organisations",
			"permission": "Your group doesn't have this permission",
			"window": "Registration is closed for this category",
			"self_approval": "You submitted this record, so someone else has to approve it",
			"role": "Your role can't do this",
			"editStatus": "Locked: only Draft or Returned records can be edited"
		},
		"tag": {
			"urgent": "Urgent",
			"multicard": "Multicard"
		},
		"journey": {
			"title": "Accreditation journey",
			"registered": "Registered",
			"draft": "Draft",
			"submitted": "Acc submitted",
			"underReview": "Under review",
			"returned": "Returned",
			"approved": "Acc approved",
			"rejected": "Rejected",
			"printing": "Printing in progress",
			"ready": "Ready to collect",
			"activated": "Acc card activated",
			"hint": {
				"DRAFT": "Complete & submit",
				"SUBMITTED": "Waiting for host review",
				"PENDING": "Host is checking eligibility",
				"RETURN": "Fix & resubmit",
				"APPROVED": "Next: card printing",
				"REJECTED": "Not accredited",
				"WITHDRAWN": "Withdrawn"
			},
			"printed": "Card printed",
			"lost": "Card lost",
			"cardHint": {
				"PRINTED": "Printed · waiting for activation",
				"COLLECTED": "Collected · waiting for activation",
				"ACTIVE": "Active · valid until {{date}}",
				"LOST": "Card reported lost, stolen or damaged"
			},
			"readyToGenerate": "Ready to generate",
			"generated": "Generated",
			"readyToSend": "Ready to send / collect",
			"readyToCollect": "Ready to collect",
			"received": "Acc card received",
			"download": "Download acc card",
			"stageHint": {
				"READY_TO_GENERATE": "In a print batch · card file not made yet",
				"GENERATED": "Card file made · waiting for the print shop",
				"PRINTING": "At the print shop",
				"PRINTED": "Back from the printer · ready to send or collect",
				"COLLECTED": "Received · waiting for activation",
				"NOC_PRINTING": "Your card is being printed",
				"NOC_PRINTED": "Ready to collect",
				"SELF_READY": "Your card is ready to download",
				"SELF_GENERATED": "Downloaded · waiting for activation"
			}
		},
		"urgentRefused": "Urgent printing wasn't changed: {{reason}}",
		"travel": {
			"notAdded": "Not added yet",
			"add": "Add",
			"addArrival": "Add arrival",
			"addDeparture": "Add departure",
			"editArrival": "Edit arrival",
			"editDeparture": "Edit departure",
			"sheetFor": "{{name}} · {{reg}}",
			"from": "From {{place}}",
			"to": "To {{place}}",
			"atEntryPointArrival": "Arrives at {{name}}",
			"atEntryPointDeparture": "Leaves from {{name}}",
			"transfer": "Games transfer",
			"noTransfer": "No Games transfer",
			"save": "Save",
			"cancel": "Cancel",
			"remove": "Remove",
			"keep": "Keep",
			"removeArrivalAsk": "Remove this arrival?",
			"removeDepartureAsk": "Remove this departure?",
			"savedArrival": "Arrival saved.",
			"savedDeparture": "Departure saved.",
			"removedArrival": "Arrival removed.",
			"removedDeparture": "Departure removed.",
			"saveArrivalFailed": "Couldn't save the arrival",
			"saveDepartureFailed": "Couldn't save the departure",
			"removeArrivalFailed": "Couldn't remove the arrival",
			"removeDepartureFailed": "Couldn't remove the departure",
			"staleTitle": "Someone else changed this travel",
			"staleBody": "Close this and open it again to see their change before you edit."
		},
		"setStatus": {
			"menu": "Set status…",
			"menuHint": "Super admin override · any status",
			"title": "Set status",
			"newStatus": "New status",
			"statusRequired": "Choose a status",
			"warning": "This skips the normal workflow and is recorded in the activity log. Leaving Approved releases beds not yet checked in. The card number stays.",
			"failed": "Couldn't set the status",
			"voidsCard": "Leaving Approved also voids the printed card: once approved again, it must be printed again."
		},
		"chain": {
			"label": "Logistics: travel, transfer, room",
			"travel": "Travel",
			"travelAdded": "Arrives {{day}}",
			"travelMissing": "No arrival added yet",
			"transferLabel": "Transfer",
			"roomLabel": "Room",
			"transfer": {
				"no_travel": "Needs an arrival first",
				"own_transport": "Own transport",
				"waiting_approval": "Waiting for approval",
				"waiting_time": "Waiting for the arrival time",
				"not_arranged": "Not arranged yet",
				"pending": "Pending a driver",
				"driver": "Driver assigned",
				"recheck": "Driver to re-check",
				"pendingRef": "Pending a driver · {{ref}}",
				"driverRef": "Driver assigned · {{ref}}",
				"recheckRef": "Driver to re-check · {{ref}}"
			},
			"room": {
				"waiting_approval": "Waiting for approval",
				"none": "No room yet",
				"assigned": "Room assigned",
				"checked_in": "Checked in",
				"checked_out": "Checked out"
			},
			"arrange": "Arrange transport",
			"openTrip": "Open trip",
			"assignRoom": "Assign room",
			"hostArranges": "The host arranges transfers and rooms; this shows where they stand."
		}
	},
	"register": {
		"title": "Register New Record",
		"editTitle": "Edit record",
		"openRecord": "Open record",
		"progress": "Step {{n}} / {{total}}",
		"savedPill": "Saved · you can finish this later",
		"steps": {
			"zone": "Zone",
			"personal": "Personal information",
			"additional": "Additional information",
			"sport": "Sport information",
			"card": "Accreditation Card",
			"review": "Review"
		},
		"stepHint": {
			"zone": "Games & category",
			"personal": "Nationality & ID",
			"additional": "Contact, medical, travel",
			"sport": "Sport & kit sizes",
			"card": "Names on the card",
			"review": "Check & submit"
		},
		"intro": {
			"zone": "Choose the category this person is accredited under.",
			"personal": "Start with the nationality. It decides which ID the person registers with. Details must match the ID exactly.",
			"additional": "How to reach the person, and what the medical team should know.",
			"sport": "The sport this person is accredited for, and their kit sizes.",
			"card": "The names printed on the card and shown in results.",
			"review": "Check everything. Name, date of birth and ID number can't be changed by the organisation after submission."
		},
		"rail": {
			"label": "Registration steps",
			"missing_one": "{{count}} item missing",
			"missing_other": "{{count}} items missing",
			"missingFields": "Missing: {{fields}}"
		},
		"help": {
			"howItWorks": "How it works",
			"title": "Need help?",
			"new": "Nothing reaches the server until Continue on Personal information creates the record. Save keeps your progress on this device.",
			"saved": "Save and Continue store your changes. Find this record any time in View Records."
		},
		"badge": {
			"done": "Done",
			"optional": "Optional",
			"toFill_one": "{{count}} to fill",
			"toFill_other": "{{count}} to fill"
		},
		"actions": {
			"back": "Back",
			"save": "Save",
			"continue": "Continue",
			"create": "Create record",
			"submit": "Submit",
			"resubmit": "Resubmit",
			"saveChanges": "Save changes"
		},
		"zone": {
			"categoryCard": "Category",
			"organisation": "Responsible organisation",
			"organisationPlaceholder": "Select an organisation",
			"groupNoc": "National Olympic Committees",
			"groupBodies": "Games bodies",
			"search": "Search",
			"category": "Category",
			"categoryPlaceholder": "Select a category",
			"numbered": "{{n}}. {{label}}",
			"pickOrgFirst": "Select an organisation first",
			"pickCategoryFirst": "Select a category first",
			"pickSubAgencyFirst": "Select the {{label}} first",
			"subAgency": "Sub-agency",
			"subAgencyPlaceholder": "Select the {{label}}",
			"noSubAgencies": "Nothing to choose for this organisation type",
			"function": "Function",
			"functionPlaceholder": "Select a function",
			"noFunctions": "This category has no functions to choose",
			"closed": "Registration closed",
			"closedOption": "{{name}} ({{code}}) · Registration closed",
			"closedError": "Registration is closed for this category. Ask the accreditation team when it opens.",
			"lockedHint": "The organisation and category can't change after submission.",
			"noGames": "No main Games is open for registration. Ask the accreditation team."
		},
		"personal": {
			"nationalityCard": "Nationality",
			"nationality": "Nationality",
			"nationalityPlaceholder": "Select nationality",
			"document": "Identity document",
			"nationalIdRule": "Malaysian citizens use MyKad",
			"passportRule": "Non-Malaysians use a passport",
			"passportNocRule": "This NOC registers with passports",
			"detailsCard": "Personal details",
			"identityLocked": "Name, ID number, nationality and date of birth are locked once the record has been submitted. Ask the host to correct them.",
			"passportNumber": "Passport number",
			"passportNumberHint": "6 to 20 letters and digits, as printed.",
			"passportNumberPlaceholder": "e.g. A12345678",
			"nationalIdNumber": "MyKad number",
			"nationalIdNumberHint": "12 digits. Dashes are added for you; date of birth and sex fill in.",
			"surname": "Surname",
			"asInPassport": "As in passport",
			"noSurname": "No surname in passport",
			"noSurnamePlaceholder": "No surname",
			"givenNames": "Given names",
			"givenNamesHint": "As printed. No accents or punctuation.",
			"givenNamesPlaceholder": "First and middle names",
			"nameAsWritten": "Name as written in MyKad",
			"nameAsWrittenHint": "Exactly as on the card, including BIN / BINTI / A/L / A/P.",
			"nameAsWrittenPlaceholder": "Full name as on the card",
			"sex": "Sex",
			"dateOfBirth": "Date of birth",
			"ageWarning": "{{age}} years old at the Games. Check the date: most people are between {{min}} and {{max}}.",
			"countryOfBirth": "Country of birth",
			"stateOfBirth": "Place of birth",
			"stateOfBirthPlaceholder": "e.g. SELANGOR",
			"countryPlaceholder": "Select country",
			"validityCard": "Passport validity",
			"issuingCountry": "Issuing country",
			"issuedDate": "Date of issue",
			"issuedFuture": "The date of issue is in the future. Check it.",
			"expiryDate": "Date of expiry",
			"expiryHint": "Must be valid until {{date}}.",
			"expiryHintNoDates": "Must be valid for 6 months after the Games end.",
			"expiryWarning": "This passport expires before {{date}}. It should be renewed before the Games."
		},
		"additional": {
			"contactCard": "Contact",
			"contactName": "Contact name",
			"contactNameHint": "Copied from the ID. Change it if someone else handles the messages.",
			"mobile": "Mobile number",
			"dialCode": "Country calling code",
			"email": "Email",
			"emailPlaceholder": "name@domain.com",
			"residence": "Country of residence",
			"address": "Residential address",
			"addressPlaceholder": "Street, city, postcode",
			"emergencyCard": "Emergency contact",
			"emergencyName": "Name",
			"emergencyNamePlaceholder": "Who should we call?",
			"relationship": "Relationship",
			"relationshipOther": "Specify relationship",
			"relationships": {
				"SPOUSE": "Spouse",
				"FATHER": "Father",
				"MOTHER": "Mother",
				"SIBLING": "Sibling",
				"CHILD": "Child",
				"RELATIVE": "Relative",
				"FRIEND": "Friend",
				"COLLEAGUE": "Colleague",
				"COACH": "Coach",
				"OTHER": "Others"
			},
			"emergencyPhone": "Phone number",
			"select": "Select",
			"medicalCard": "Medical & meals",
			"bloodGroup": "Blood group",
			"meals": "Meal requirements",
			"meal": {
				"HALAL": "Halal",
				"VEGETARIAN": "Vegetarian",
				"VEGAN": "Vegan",
				"NO_BEEF": "No beef",
				"NO_PORK": "No pork",
				"GLUTEN_FREE": "Gluten-free",
				"LACTOSE_FREE": "Lactose-free",
				"NUT_ALLERGY": "Nut allergy"
			},
			"allergies": "Allergies",
			"allergiesPlaceholder": "e.g. penicillin, shellfish",
			"medical": "Medical conditions",
			"medicalPlaceholder": "e.g. asthma, recent injury",
			"wheelchair": "Wheelchair user",
			"wheelchairHint": "For accessible transport and seating",
			"wheelchairType": "Wheelchair type",
			"wheelchairTypes": {
				"MANUAL": "Manual",
				"MOTORISED": "Motorised"
			},
			"travelCard": "Arrival & departure",
			"travelLater": "The organisation can complete this later. Used for the airport welcome and transport.",
			"travelReadOnly": "You can see this travel but not change it.",
			"removeDeparture": "Remove departure",
			"removeArrival": "Remove arrival",
			"addDeparture": "Add departure",
			"addArrival": "Add arrival",
			"arrival": "Arrival",
			"departure": "Departure",
			"mediaCard": "Media organisation",
			"mediaOrg": "Media organisation",
			"jobTitle": "Job title",
			"mediaPhone": "Organisation phone",
			"mediaEmail": "Organisation email",
			"mediaAddress": "Organisation address"
		},
		"sport": {
			"sportCard": "Sport",
			"sport": "Sport",
			"sportPlaceholder": "Select sport",
			"sportHint": "Filled in from the national federation when it has one.",
			"profileCard": "Athlete profile",
			"height": "Height",
			"weight": "Weight",
			"unitCm": "cm",
			"unitKg": "kg",
			"shirt": "Shirt size",
			"shoe": "Shoe size (EU)"
		},
		"card": {
			"namesCard": "Accreditation Name",
			"nameOnCard": "Accreditation Name",
			"nameOnCardHint": "Printed on the card. Shorten long names if you like.",
			"nameMax": "The name can't be longer than {{max}} characters.",
			"counter": "{{n}}/{{max}}",
			"tvName": "Name in results & on TV",
			"tvNameHint": "Short form shown in results and on TV, e.g. A. RAHMAN.",
			"useSuggestion": "Use {{name}}"
		},
		"review": {
			"noSurname": "No surname",
			"cm": "{{n}} cm",
			"kg": "{{n}} kg",
			"urgent": "Urgent printing",
			"urgentHint": "Put this card at the front of the AC-card print queue",
			"declarations": "Declarations",
			"declTruthId": "The details above match the MyKad and are true.",
			"declTruthPassport": "The details above match the passport and are true.",
			"declPdpa": "The person agrees that the organisers may process their personal data for accreditation, security and Games services."
		},
		"checkpoint": {
			"title": "Registration created",
			"body": "Zone and personal information are saved and visible to the organisation. Finish the rest now or later, then submit.",
			"stillToDo": "Still to do",
			"steps_one": "{{count}} step",
			"steps_other": "{{count}} steps",
			"finishLaterHint": "Come back any time from View Records. You submit for host review at the end.",
			"finishLater": "Finish later",
			"continueNow": "Continue now"
		},
		"done": {
			"title": "Registration submitted",
			"titleResubmitted": "Registration resubmitted",
			"body": "The host's accreditation team reviews it next. You can follow it from View Records.",
			"next": "What happens next",
			"steps": {
				"submitted": "Submitted",
				"review": "Host review",
				"printed": "Card printed",
				"collect": "Collect your card"
			},
			"stepHints": {
				"submitted": "Sent to the host",
				"review": "Security and eligibility checks",
				"printed": "After approval",
				"collect": "Accreditation centre, venue to be confirmed"
			},
			"registerAnother": "Register another",
			"viewRecord": "View record"
		},
		"duplicate": {
			"inScopeTitle": "This person is already in your records",
			"adminTitle": "This ID is already registered",
			"person": "{{name}} · {{country}}",
			"inScopeHint": "Open their record, or add another card for them under this category.",
			"adminHint": "Their cards are listed above. You can add a card for this person instead of a new registration.",
			"openRecord": "Open record",
			"addCard": "Add another card",
			"changeId": "Change the ID number",
			"registered": "This ID is already registered. Contact the accreditation team.",
			"rateLimited": "Too many ID checks. Try again in a few minutes."
		},
		"errors": {
			"summary_one": "{{count}} field needs attention",
			"summary_other": "{{count}} fields need attention",
			"missingTitle_one": "{{count}} required field is missing",
			"missingTitle_other": "{{count}} required fields are missing",
			"invalid": "Check this value",
			"chain": "Doesn't fit the organisation or category chosen",
			"staleTitle": "Someone else changed this record",
			"staleBody": "Reload to see their changes. Your unsaved changes on this page will be lost.",
			"reload": "Reload",
			"closedTitle": "Registration is closed",
			"closedBody": "The registration window for this category is not open. Ask the accreditation team.",
			"identityLockedTitle": "Identity details are locked",
			"sameCardTitle": "This person already has this card",
			"sameCardBody": "They already hold a card for this organisation, category and function in these Games."
		},
		"toast": {
			"savedLocal": "Saved on this device",
			"storageUnavailable": "This browser can't keep a draft. Continue to create the record.",
			"saved": "Saved",
			"saveFailed": "Couldn't save",
			"createFailed": "Couldn't create the record",
			"checkFailed": "Couldn't check the ID",
			"submitFailed": "Couldn't submit",
			"reloaded": "Reloaded the latest version",
			"notEditable": "You can change only Draft or Returned records"
		},
		"restored": {
			"title": "Draft restored",
			"body": "Your unsaved Zone and Personal details from this device are back.",
			"discard": "Start over"
		},
		"noPermission": {
			"title": "You can't register records",
			"body": "Your group has no permission to register people. Contact your administrator."
		}
	},
	"uniqueCode": {
		"label": "Unique code",
		"inline": "Unique code:",
		"verified": "Verified",
		"none": "No sign-in yet",
		"copy": "Copy unique code",
		"copied": "Unique code copied",
		"copyFailed": "Couldn't copy. Select the code and copy it by hand."
	}
}
